export const PARAMS_ADMIN_PROTECTORA = {
    id: {
        prefix: "",
        name: ":id",
        suffix: ""
    },
    id_animal: {
        prefix: "",
        name: ":id_animal",
        suffix: ""
    },
}

export const routes = {
    protectoraId: `${PARAMS_ADMIN_PROTECTORA.id.name}`,
    login: 'login',
    perfil: 'perfil',
    perfilParticular: 'perfilParticular',
    registro: 'registro',
    registroParticulares: 'registroParticulares',
    registroGracias: 'registro/gracias',
    registroEmailVerificado: 'registro/emailVerificado',
    cambiarPassword: 'cambiar-contraseña',
    servicios: "servicios",
    contactaConNostros: "contacta-con-nosotros",
    adminAnimals: `adminAnimals`,
    animalNuevo: "animal/nuevo",
    animalModificar: `animal/${PARAMS_ADMIN_PROTECTORA.id_animal.name}`
}

export const routesPrefix = {
    root: '/buscador/admin',
    protectoraRoot : '/protectora'
}